<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="Author-bio" lang="en-US">Sandra currently lives in Toronto, Ontario, Canada. She was a systems analyst prior to her career as an author.</p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-US"><span class="CharOverride-1" lang="">Pets were important to Sandra and her sisters, and they had a cat and a dog in their family while growing up in Bowmanville.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781638298854_EPUB2.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="copyright" lang="en-US">Copyright © Sandra McGregor 2024</p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-3" lang="">Ordering Information</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-3" lang="">Publisher’s Cataloging-in-Publication data</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">McGregor, Sandra </span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">The Adventures Of Finnigan</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">ISBN 9781638298854 (Paperback)</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">ISBN 9781638298861 (ePub e-book)</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">Library of Congress Control Number: 2023922281</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">www.austinmacauley.com/us</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">First Published 2024</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">Austin Macauley Publishers LLC</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">40 Wall Street, 33rd Floor, Suite 3302 </span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">New York, NY 10005</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">USA</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-2" lang="">mail-usa@austinmacauley.com</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US">+1 (646) 5125767</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Author-bio" lang="en-US">This book is dedicated to the memory of my father who, by example, taught my sisters and me how to care for our pets.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781638298854_EPUB6.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer016">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer017">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer023">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer024">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer026">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer028">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer029">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer032">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer034">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer035">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer036">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer038">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer039">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer040">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer041">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer042">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer043">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer044">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer045">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer046">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer047">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer048">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer049">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer050">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer051">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer052">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer053">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer054">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer055">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer056">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer057">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer058">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB27.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer059">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer060">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB28.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer061">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer062">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB29.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer063">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB30.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer064">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer065">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB31.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer066">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer067">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB32.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer068">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer069">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB33.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer070">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer071">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB34.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer072">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer073">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB35.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer074">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer075">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB36.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer076">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer077">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB37.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer078">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer079">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB38.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer080">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer081">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB39.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer082">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer083">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB40.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer084">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer085">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781638298854_EPUB41.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer086">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NEW_EPUB.vue?6708b4c2